<template>
  <div class="container">
    <!--Botones de Confirmación y Edición-->
    <div class="d-flex justify-content-end m-2">
      <!--Dropdown de edición-->
      <b-dropdown
        id="dropdown-1"
        size="sm"
        variant="info"
        :class="{ ocultarClass: esHome }"
        text="Editar Elemento"
        class="btn-elemento btn-options"
        v-show="showMenu"
        v-on:click=";(showPosition = false), (showAnimation = false)"
      >
        <b-dropdown-item
          @click=";(loadGallery = true), displayEdit(), (loadCarousel = false)"
          >Editar Galeria</b-dropdown-item
        >
        <b-dropdown-item
          @click=";(loadCarousel = true), (loadGallery = false), displayEdit()"
          >Editar Carousel</b-dropdown-item
        >
        <b-dropdown-item
          @click="
            showAnimation == true
              ? (showAnimation = false)
              : (showAnimation = true)
          "
          >Agregar animación</b-dropdown-item
        >
        <!--<b-dropdown-item
          @click="
            showPosition == true
              ? (showPosition = false)
              : (showPosition = true)
          "
          >Ajustar posición</b-dropdown-item
        >-->
      </b-dropdown>
    </div>
    <div v-show="showAnimation" class="options">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar animacion</p>
        </div>
        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div
              @click="addAnimation('fade')"
              class="btn btn-primary py-2 px-2 animation-fade"
            >
              FadeIn
            </div>
            <div style="overflow:hidden ">
              <div
                @click="addAnimation('bounce')"
                class="btn btn-warning py-2 px-2 animation-bounce"
              >
                Bounce
              </div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <div
                @click="addAnimation('lr')"
                class="btn btn-primary py-2 px-2 animation-slide-l-r"
              >
                Slide in
              </div>
            </div>
            <div style="overflow:hidden">
              <div
                @click="addAnimation('rl')"
                class="btn btn-warning py-2 px-2 animation-slide-r-l"
              >
                Slide in
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button
              size="sm"
              v-on:click="showAnimation = false"
              variant="success"
              >Guardar</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-show="showPosition" class="pb-2 options col-6">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h3">Posicionar</p>
        </div>
        <div class="p-3">
          <b-button-group
            size="sm"
            class="d-flex flex-row justify-content-center"
          >
            <b-button
              @click="changePosition('left')"
              class="mx-4"
              active
              variant="outline-success"
            >
              <img src="@/assets/f-left.svg" alt />
            </b-button>
            <b-button
              @click="changePosition('center')"
              class="mx-4"
              variant="outline-info"
            >
              <img src="@/assets/f-center.svg" alt />
            </b-button>
            <b-button
              @click="changePosition('right')"
              class="mx-4"
              variant="outline-warning"
            >
              <img src="@/assets/f-right.svg" alt />
            </b-button>
          </b-button-group>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            size="sm"
            v-on:click="showPosition = false"
            variant="success"
            >Guardar</b-button
          >
        </div>
      </div>
    </div>
    <!-- NOTE Seccion del modal de edicion de la galería. -->
    <div class="d-flex">
      <div class="col-12">
        <b-modal
          :id="'modal-edicion' + this.uid"
          size="xl"
          title="Imágenes para galería y carousel"
          @ok="saveImages()"
          scrollable
          no-close-on-backdrop
        >
          <div class="container-fluid">
            <!-- NOTE Seccion del Carousel -->
            <div v-show="loadCarousel" class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-12">
                          <!-- NOTE Input para cargar images al carousel -->
                          <b-form-file
                            class="my-3"
                            v-model="imagesTemp"
                            multiple
                            accept="image/*"
                            placeholder="Puedes cargar cinco imágenes al mismo tiempo, o individualmente."
                            drop-placeholder="Drop file here..."
                            browse-text="Buscar"
                            :file-name-formatter="displayImagesCarousel"
                          ></b-form-file>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <!-- <b-button
                      v-on:click="
                        ;(existeCarousel = !existeCarousel),
                          (muestraCarousel = false)
                      "
                      size="sm"
                      variant="primary"
                      class="m-2 p-2"
                    >No usar Carousel</b-button>-->
                  </div>

                  <b-form-radio
                    class="mx-4"
                    v-model="muestraCarousel"
                    name="radiocaru"
                    :value="false"
                    >No usar Carousel</b-form-radio
                  >
                  <b-form-radio
                    class="mx-4"
                    v-model="muestraCarousel"
                    name="radiocaru"
                    :value="true"
                    >Usar Carousel</b-form-radio
                  >
                </div>
                <!-- NOTE Display Preview Carousel -->
                <div class="row">
                  <div class="col-12">
                    <div class="my-3">
                      <p class="h3">PREVIEW DE CAROUSEL</p>
                      <p v-if="imagesTemp.length <= 0" class="h5">
                        <small>CARGA IMAGENES PARA PRE-VISUALIZARLAS</small>
                      </p>
                    </div>
                    <div class="row mt-4">
                      <!-- NOTE Preview Carousel -->
                      <div
                        v-for="(img, index) in carouselPreview"
                        :key="index"
                        class="col-3 box-img my-3"
                        draggable="true"
                        @dragover.prevent
                        @dragstart="dragStart(index)"
                        @dragend="dragEnd"
                        @drop="dragFinish(index, 'carousel')"
                      >
                        <img
                          @click="removeItem(index, 'carousel')"
                          class="delete-icon"
                          src="@/assets/Icons/delete.svg"
                          alt
                        />
                        <img
                          class="img img-thumbnail"
                          :src="img.url"
                          :alt="img.alt"
                        />
                      </div>
                    </div>
                    <div class="my-3">
                      <p class="h3">IMAGENES DEL CAROUSEL</p>
                    </div>
                    <div class="row mt-1">
                      <!-- NOTE Imagenes Carousel -->
                      <div
                        v-for="(img, index) in carousel"
                        :key="index"
                        class="col-3 box-img my-3"
                        draggable="true"
                        @dragover.prevent
                        @dragstart="dragStart(index)"
                        @dragend="dragEnd"
                        @drop="dragFinish(index, 'carousel')"
                      >
                        <img
                          @click="removeItem(index, 'carousel')"
                          class="delete-icon"
                          src="@/assets/Icons/delete.svg"
                          alt
                        />
                        <img
                          class="img img-thumbnail"
                          :src="img.url"
                          :alt="img.alt"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- NOTE Seccion de galeria -->
            <div v-show="loadGallery" class="row">
              <div class="col-12">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12">
                      <!-- NOTE Input upload images to Gallery -->
                      <b-form-file
                        v-model="imagesTemp"
                        multiple
                        accept="image/*"
                        placeholder="Puedes cargar multiples imágenes a la vez, o individualmente."
                        drop-placeholder="Drop file here..."
                        :file-name-formatter="displayImagesGallery"
                        browse-text="Buscar"
                      ></b-form-file>
                    </div>
                  </div>
                  <!-- NOTE input de audio -->
                  <div class="row py-3">
                    <div class="col-12">
                      <b-form-file
                        size="sm"
                        accept="audio/*"
                        browse-text="Abrir"
                        placeholder="Selecciona el audio para la galería."
                        :file-name-formatter="setAudio"
                      ></b-form-file>
                    </div>
                  </div>
                  <div class="row py-3">
                    <div class="col-12">
                      <button
                        v-if="showButtonGallery"
                        @click="
                          {
                            showButtonGallery = !showButtonGallery
                          }
                        "
                        class="btn btn-primary"
                      >
                        Ocultar botón galería
                      </button>
                      <button
                        v-else
                        class="btn btn-warning"
                        @click="
                          {
                            showButtonGallery = !showButtonGallery
                          }
                        "
                      >
                        Mostrar botón galería
                      </button>
                    </div>
                  </div>
                  <div class="my-3">
                    <p class="h3">PREVIEW DE IMAGENES</p>
                    <p v-if="imagesTemp.length <= 0" class="h5">
                      <small>CARGA IMAGENES PARA PRE-VISUALIZARLAS</small>
                    </p>
                  </div>
                  <div class="row mt-4">
                    <!-- NOTE Display PReview Galeria-->
                    <div
                      v-for="(img, index) in imagesPreview"
                      :key="index"
                      class="col-3 box-img my-3"
                      draggable="true"
                      @dragover.prevent
                      @dragstart="dragStart(index)"
                      @dragend="dragEnd"
                      @drop="dragFinish(index, 'images')"
                    >
                      <img
                        @click="removeItem(index, 'images')"
                        class="delete-icon"
                        src="@/assets/Icons/delete.svg"
                        alt
                      />
                      <img
                        class="img img-thumbnail"
                        :src="img.url"
                        :alt="img.alt"
                      />
                    </div>
                  </div>
                  <hr style="height: 1em !important; width: 100% !important" />
                  <div class="my-3">
                    <p class="h3">IMAGENES GUARDADAS EN LA GALERIA</p>
                  </div>
                  <div class="row mt-4">
                    <!-- NOTE V-for de las imagenes contenidas en la galeria -->
                    <div
                      v-for="(img, index) in images"
                      :key="index"
                      class="col-3 box-img my-3"
                      draggable="true"
                      @dragover.prevent
                      @dragstart="dragStart(index)"
                      @dragend="dragEnd"
                      @drop="dragFinish(index, 'images')"
                    >
                      <img
                        @click="removeItem(index, 'images')"
                        class="delete-icon"
                        src="@/assets/Icons/delete.svg"
                        alt
                      />
                      <img
                        class="img img-thumbnail"
                        :src="img.url"
                        :alt="img.alt"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
            <b-button size="sm" variant="success" @click="ok()">Guardar</b-button>
          </template>-->
        </b-modal>
      </div>
    </div>

    <!-- Aqui esta el carousel -->
    <div v-show="muestraCarousel" class="row">
      <div id="CARU" class="container gallery-container col-6">
        <div ref="gallery" class="d-flex flex-column">
          <img
            v-if="emptyCarousel"
            class="img-thumbnail"
            :src="currentImageCarousel"
            alt="imagen-carousel"
          />

          <div class="d-flex">
            <div class="col">
              <div
                class="botones-box d-flex flex-row justify-content-around mt-3"
              >
                <img
                  @click="prevImage('carousel')"
                  class="arrows-style"
                  src="@/assets/Icons/arrow_back.svg"
                  alt
                />
                <img
                  v-if="isPlaying"
                  @click="pauseCarousel()"
                  class="arrows-style"
                  src="@/assets/Icons/pause.svg"
                  alt
                />
                <img
                  v-else
                  @click="playCarousel('carousel')"
                  class="arrows-style"
                  src="@/assets/Icons/play.svg"
                  alt
                />
                <img
                  @click="nextImage('carousel')"
                  class="arrows-style"
                  src="@/assets/Icons/arrow_forward.svg"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- NOTE aquí está la galeria -->
    <b-modal
      size="lg"
      :id="'modal-galeria' + this.uid"
      @close="pauseAudio"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <div class="container-fluid">
        <div class="row">
          <div class="gallery-container container">
            <div class="row">
              <div class="col-12 d-flex flex-row justify-content-center">
                <img class="img" :src="currentImage" alt />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div
                  class="botones-box d-flex flex-row justify-content-around mt-3"
                >
                  <img
                    @click="prevImage('images')"
                    class="arrows-style"
                    src="@/assets/Icons/arrow_back.svg"
                    alt
                  />
                  <img
                    v-if="isPlaying"
                    @click="pauseCarousel()"
                    class="arrows-style"
                    src="@/assets/Icons/pause.svg"
                    alt
                  />
                  <img
                    v-else
                    @click="playCarousel('images')"
                    class="arrows-style"
                    src="@/assets/Icons/play.svg"
                    alt
                  />
                  <img
                    @click="nextImage('images')"
                    class="arrows-style"
                    src="@/assets/Icons/arrow_forward.svg"
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <div class="d-flex justify-content-center">
      <!--<div class="col-12">
        <b-button @click="displayEdit()" size="lg" variant="warning">Editar galería</b-button>
      </div>-->
      <div class="my-3">
        <b-button
          v-show="showButtonGallery"
          @click="displayGallery()"
          size="lg"
          variant="primary"
          >Ver galería completa</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// import deleteIcon from '@/assets/detele.svg'
import firebase from 'firebase'
import db from './firebaseInit'

export default {
  name: 'Gallery',
  props: {
    data: Object,
    idSection: String,
    subid: Number,
    esHome: Boolean,
    elementid: Number
  },
  // components: { Imagen },
  data() {
    return {
      showButtonGallery: false,
      emptyCarousel: false,
      showPreview: true,
      carouselPreview: [],
      imagesPreview: [],
      images: [], // array final con las imágenes de la galería en JSON.
      testyData: 'hellour',
      imagesTemp: [], // Temporalmente almacena los archivos de imagen
      imagesGallery: [],
      currentImage: '',
      currentImageCarousel: '',
      position: 0,
      dragging: -1,
      aux: [],
      showGallery: false,
      isPlaying: false,
      playState: 0,
      // audio: {
      //   src: '',
      //   playing: false
      // },
      audio: null,
      carousel: [],
      loadGallery: false,
      loadCarousel: false,
      muestraCarousel: true,
      existeCarousel: true,
      localRoot: null,
      imagesStorage: null,
      carouselStorage: null,
      setExiste: null,
      showAnimation: false,
      showPosition: false,
      showMenu: true,
      animation: '',
      positionGallery: '',
      imgsToStore: [],
      namesAndURLS: [],
      promises: [],
      urls: [],
      imagesToFirebase: [],
      carouselToFirebase: [],
      myurls: []
    }
  },

  methods: {
    // * Methods hadling the Firebase Upload of Images

    uploadImageToFirebase(type, image) {
      let uploadPath = '/' + type + '/'
      let uploadReference = firebase.storage().ref(uploadPath + image.name)
      return uploadReference.put(image)
    },

    getImagesFromRoot(location) {
      if (!location) return

      this[location] = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid][
        'gallery_settings'
      ][1][location]

      if (this[location] === undefined || this[location] === '')
        this[location] = []

      if (location === 'carousel') {
        this.carousel[0] === undefined ||
        this.carousel[0] === '' ||
        this.carousel[0] === null
          ? (this.emptyCarousel = false)
          : (this.emptyCarousel = true)
      }
    },

    nextImage(array) {
      this.position >= this[array].length - 1
        ? (this.position = 0)
        : this.position++
      if (array === 'carousel') {
        this.currentImageCarousel = this.carousel[this.position].url
      } else {
        this.currentImage = this.images[this.position].url
      }
    },
    prevImage(array) {
      this.position == 0
        ? (this.position = this[array].length - 1)
        : this.position--
      if (array === 'carousel') {
        this.currentImageCarousel = this[array][this.position].url
      } else {
        this.currentImage = this[array][this.position].url
      }
    },

    removeItem(index, array) {
      if (this.imagesTemp.length > 0) {
        // this[array + 'Preview'].splice(index, 1)
        // ? Jaja todavia no entiedo por que imesTemp afecta directamente al Preview, WTF
        this[array + 'Preview'] = []
        this.imagesTemp.splice(index, 1)
        // console.log(this[array + 'Preview'])
        // this[array + 'Preview'] = []
        // if (array === 'carousel') {
        //   this.displayImagesCarousel()
        // } else {
        //   this.displayImagesGallery()
        // }
      } else {
        this[array].splice(index, 1)
        this.saveArrayToRoot(array)
      }
    },

    dragStart(which) {
      this.dragging = which
    },
    dragEnd() {
      this.dragging = -1
    },
    dragFinish(to, array) {
      this.moveItem(this.dragging, to, array)
    },

    moveItem(from, to, array) {
      // array es cual de los dos arrays se va a utilizar, images para galeria, o carousel
      // para el carousel
      if (to === -1) {
        this.removeItemAt(from)
      } else {
        this[array].splice(to, 0, this[array].splice(from, 1)[0])
      }
    },
    // * Para mostrar las imagenes en el menu de imput (todavia no se suben a Firebase)
    displayImagesGallery() {
      for (let index = 0; index < this.imagesTemp.length; index++) {
        const reader = new FileReader()
        let imageObject = {}
        imageObject.name = this.imagesTemp[index].name

        reader.onloadend = function() {
          imageObject.url = reader.result
          this.imagesPreview.push(imageObject)
        }.bind(this)

        reader.readAsDataURL(this.imagesTemp[index])
      }
    },

    displayImagesCarousel() {
      for (let index = 0; index < this.imagesTemp.length; index++) {
        const reader = new FileReader()
        let imageObject = {}
        imageObject.name = this.imagesTemp[index].name

        reader.onloadend = function() {
          imageObject.url = reader.result
          this.carouselPreview.push(imageObject)
        }.bind(this)

        reader.readAsDataURL(this.imagesTemp[index])
      }
    },

    saveArrayToRoot(type) {
      if (!this.localRoot) {
        alert('Ocurrio un error')
        return
      }

      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['gallery_settings'][1][
        type
      ] = this[type]

      window.localStorage.setItem('root', JSON.stringify(this.localRoot))

      type === 'carousel'
        ? ((this.currentImageCarousel = this.carousel[0].url),
          (this.emptyCarousel = true))
        : (this.currentImage = this.images[0]).url
    },

    // * Once that OK button is pressed, upload images to Firebase
    saveImages() {
      if (this.loadGallery) this.saveToFirebase('images')
      if (this.loadCarousel) this.saveToFirebase('carousel')
    },

    saveToFirebase(location) {
      if (this.imagesTemp.length > 0) {
        // * Inicio el loader para bloquear la interaccion
        this.$loading(true)

        // * funcion que maneja toda la carga y armado del array final de names y urls.
        let uploadTofirebase = async () => {
          this.carouselPreview = []
          this.imagesPreview = []
          let promises = []
          let downloadedIMGS = []
          let urls = []
          let names = []
          // * Creo un array de promesas de la subida de cada imagen.
          this.imagesTemp.map(image => {
            promises.push(this.uploadImageToFirebase(location, image))
            names.push(image.name)
          })

          // * Espero a que todas las imagenes se suban a FireStore
          await Promise.all(promises)
            .then(result => {
              downloadedIMGS = [...result]
            })
            .catch(e => {
              console.log(`Error in ${e}`)
              this.$loading(false)
            })

          // * Ahora, con el snapshot de cada imagen
          // * subida, llamo a getDownloadURL, que devuelve una Promesa.
          downloadedIMGS.map(img => {
            urls.push(img.ref.getDownloadURL())
          })

          await Promise.all(urls).then(url => {
            this.myurls = [...url]
          })

          // * Creo el array final de imagenes.

          let createFinalArray = limite => {
            return new Promise((resolve, reject) => {
              let tempIndex = 0
              this.myurls.forEach(url => {
                let temporalObject = {}
                temporalObject.url = url
                temporalObject.name = names[tempIndex]
                console.log(names[tempIndex])
                this[location].push(temporalObject)
                console.log(temporalObject)
                temporalObject = {}
                tempIndex++
              })

              if (tempIndex === undefined) {
                reject('Erroororor')
              }

              if (tempIndex === limite) {
                resolve(`Listo`)
              }
            })
          }

          await Promise.all([createFinalArray(this.myurls.length)]).then(
            result => {
              console.log(result)
            }
          )
          // await createFinalArray(this.myurls.length)
          this.saveArrayToRoot(location)

          // ? Limpiar estos arrays, can they  be cleansed inside then of Promise.all
          this.myurls = []
          this.imagesTemp = []
          this[location + 'Preview'] = []
          this.$loading(false)
        }

        uploadTofirebase()
      } else {
        if (this.loadGallery) this.saveArrayToRoot('images')
        if (this.loadCarousel) this.saveArrayToRoot('carousel')
      }
    },

    // FIXME the last posiiton in the array is not getting stored in the db
    saveToDatabase(location) {
      // 'galeries' y 'carousel'
      console.log('Names and URLS: \n')

      // this.getImagesFromFirebase(location)
      // this[location + 'ToFirebase'] = []

      this.namesAndURLS.forEach(element => {
        this[location + 'ToFirebase'].push(element)
      })

      console.log(this[location])

      db.collection(location)
        .doc(this.idSection)
        .set({
          images: this[location + 'ToFirebase']
        })
        .then(() => {
          alert('Imagenes guardadas uwu')
          this.namesAndURLS = []
          this.promises = []
          this[location + 'ToFirebase'] = []
          this.imagesTemp = []
          this.getImagesFromFirebase(location)
        })
        .catch(Error => {
          console.log(Error)
        })
    },

    showTemp(type) {
      console.log(this.imagesTemp)
      console.log(type)
    },

    saveCarousel() {
      this.carouselStorage.guardar(this.carousel)
    },
    displayGallery() {
      //this.muestraCarousel = false
      // this.showGallery = true
      this.currentImage = null
      this.currentImage = this.images[this.position].url
      if (this.images[this.position].url === undefined) {
        this.position = 0
        this.currentImage = this.images[this.position].url
      }

      this.$bvModal.show('modal-galeria' + this.uid)
      if (this.audio != null) this.audio.play()
    },

    displayEdit() {
      // this.images = this.obtener(this.key_images)
      // this.showEdit = !this.showEdit
      // this.namesAndURLS = this.images
      this.$bvModal.show('modal-edicion' + this.uid)
    },
    playCarousel(array) {
      if (this.playState === 0) {
        this.isPlaying = !this.isPlaying
      }
      this.playState = setTimeout(() => {
        this.nextImage(array)
        this.playCarousel(array)
      }, 3000)
    },
    pauseCarousel() {
      this.isPlaying = !this.isPlaying
      clearTimeout(this.playState)
      this.playState = 0
    },
    setAudio(file) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      //const urlObj = URL.createObjectURL(file[0])
      let audioitem = new Audio('audios/' + file[0].name)
      //this.img = "imgs/"+file[0].name
      // audioitem.src(urlObj)
      this.audio = audioitem
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['gallery_settings'][1][
        'audio'
      ] = 'audios/' + file[0].name
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    playAudio() {
      // let audioitem = this.$refs.audiogalleryref
      // this.audio.play()
    },
    pauseAudio() {
      if (this.audio != null) this.audio.pause()
      this.position = 0
      // if (this.muestraCarousel) {
      //   console.log('entre')
      //   this.currentImage = this.carousel[this.position].url
      // } else this.currentImage = this.images[this.position]
    },
    addAnimation(type) {
      if (type === undefined) return
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      switch (type) {
        case 'rl':
          /*this.$refs.popsref.classList.remove('animation-slide-l-r')
              this.$refs.imgref.classList.remove('animation-bounce')
              this.$refs.imgref.classList.remove('animation-fade')
              this.$refs.imgref.classList.add('animation-slide-r-l')*/
          this.animation = 'rl'
          break

        case 'lr':
          /*this.$refs.imgref.classList.remove('animation-slide-r-l')
              this.$refs.imgref.classList.remove('animation-bounce')
              this.$refs.imgref.classList.remove('animation-fade')
              this.$refs.imgref.classList.add('animation-slide-l-r')*/
          this.animation = 'lr'
          break
        case 'bounce':
          /*this.$refs.imgref.classList.remove('animation-slide-l-r')
              this.$refs.imgref.classList.remove('animation-slide-r-l')
              this.$refs.imgref.classList.remove('animation-fade')
              this.$refs.imgref.classList.add('animation-bounce')*/
          this.animation = 'bounce'
          break
        case 'fade':
          this.animation = 'fade'
          break

        default:
          break
      }
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['animation'] = this.animation
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    changePosition(position) {
      if (position === '' || position === undefined) return
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      switch (position) {
        case 'left':
          this.$refs.gallery.classList.remove('justify-content-end')
          this.$refs.gallery.classList.remove('justify-content-center')
          this.$refs.gallery.classList.add('justify-content-start')
          this.positionGallery = 'left'
          break
        case 'center':
          this.$refs.gallery.classList.remove('justify-content-start')
          this.$refs.gallery.classList.remove('justify-content-end')
          this.$refs.gallery.classList.add('justify-content-center')
          this.positionGallery = 'center'
          break
        case 'right':
          this.$refs.gallery.classList.remove('justify-content-start')
          this.$refs.gallery.classList.remove('justify-content-center')
          this.$refs.gallery.classList.add('justify-content-end')
          this.positionGallery = 'right'
          break

        default:
          break
      }
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ]['elements'][this.subid]['position'] = this.positionGallery
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    }
  },
  created() {
    // * Obtenemos el root para tenerlo local y no hacer una invocación distinta en cada metodo.
    this.localRoot = JSON.parse(localStorage.getItem('root'))
    // * Encendemos la bandera para denotar que una galeria existe y no puede existir otra.
    this.setExiste = this.localRoot['componentes']['secciones'][this.idSection][
      'existeGaleria'
    ]

    // * Obtenemos y reproducimos un archivo de audio para el componente audio de la Galeria.
    let existeAudio = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones'][this.subid]['elements'][this.elementid][
      'gallery_settings'
    ][1]['audio']

    if (existeAudio) {
      this.audio = new Audio(existeAudio)
    }

    if (this.audio) this.audio.pause()

    // * Get images e imagenes del carousel
    this.getImagesFromRoot('images')
    this.getImagesFromRoot('carousel')

    // TODO  Animaciones y la posicion, verificar las rutas.
    this.animation = this.localRoot['componentes']['secciones'][this.idSection][
      'subsecciones'
    ][this.subid]['elements'][this.elementid]['animation']
    this.positionGallery = this.localRoot['componentes']['secciones'][
      this.idSection
    ]['subsecciones']['elements'][this.subid].position
  },
  mounted() {
    // TODO verificar estos metodos, y poner condiciones de salida en undefined.
    this.changePosition(this.positionGallery)
    this.addAnimation(this.animation)
    this.currentImageCarousel = this.carousel[0].url

    // this.carouselPreview = [...this.carousel]
    // this.imagesPreview = [...this.images]
  }
}
</script>

<style scoped>
.img-element {
  height: 100%;
  width: auto;
}
.box-img {
  height: 15em;
  position: relative;
}
.delete-icon {
  position: absolute;
  z-index: 99;
  top: 3%;
  left: 5%;
  height: 3em;
  cursor: pointer;
  fill: chartreuse;
}
.gallery-container img {
  max-height: 400px;
}
.img-itself {
  position: relative;
}
.arrows-style {
  height: 3em;
}
.arrows-style:hover {
  cursor: pointer;
}
.img-galeria {
  height: 40em;
  width: auto;
}
.img-carousel {
  height: 30em;
  widows: auto;
}
</style>
